import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (phoneNum) => `${API_URL}/api/v1/register/${phoneNum}`;

const createLead = async (phoneNum) => await apiRequest(getUrl(phoneNum), "get");

export default createLead;
